import React from "react";

import { useTranslation } from "src/hooks/translation";
import Timer from "src/common/components/timer";
import { IDefer } from "src/constants/interfaces";

interface IProps {
	defer: IDefer<boolean>;
}

const VerificationLogoutPopup = ({ defer }: IProps) => {
	const t = useTranslation();

	const onCancel = () => defer.resolve(false);

	const onLogOut = () => {
		defer.resolve(true);
	};

	return (
		<div className="B-popup-wrapper">
			<div className="B-popup-content B-popup-small">
				<h3 className="B-popup-title">{t("Would you like to log out")}</h3>
				<div className="B-popup-main-content">
					<i className="global-icon icon-logout B-icon" />
					<p className="text-center">{t("You will be logged out automatically after")}</p>
					<Timer duration={10} onFinish={onLogOut} />
				</div>

				<button className="B-popup-cancel-button" onClick={onCancel}>
					{t("Cancel")}
				</button>
				<button className="B-popup-confirm-button" onClick={onLogOut}>
					{t("Log out")}
				</button>
			</div>
		</div>
	);
};

export default VerificationLogoutPopup;
